// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"fa5e2ecd667e9639823f","453":"4b169213c09bc687cec2"}[chunkId] + ".js";
};